import React, { useState, useEffect } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import { Routes } from "./routes"

// pages

// components

import { Container } from "react-bootstrap"
import OneSignal from "react-onesignal"
import CustomerDetailPage from "./pages/Customers/CustomerDetailPage"
import DashboardPage from "./pages/DashboardPage"
import VisitReportPage from "./pages/VisitReportPage"
import CustomerPage from "./pages/Customers/CustomerPage"
import SelectOrganization from "./components/Organizations/SelectOrganization"
import SettingsPage from "./pages/SettingsPage.tsx"
import Preloader from "./components/Preloader"
import Login from "./components/Profile/Login"
import HomePage from "./pages/HomePage"
import ResponsiveNavbar from "./components/Common/Navbar"
import AgentVisitsPage from "./pages/AgentVisitsPage"
import Settings from "./common/Settings"
import AgentsPage from "./pages/Agents/AgentsPage"
import AgentDetailsPage from "./pages/Agents/AgentDetailsPage"

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <Route
      {...rest}
      render={props => (
        <>
          <Preloader show={loaded ? false : true} />
          {/* <OmniBar /> */}
          {/* <Sidebar repsly={rest.repsly} /> */}
          <ResponsiveNavbar />
          <Container fluid className="px-0">
            <Component {...props} />
          </Container>
        </>
      )}
    />
  )
}

export default () => {
  const runOneSignal = async () => {
    await OneSignal.init({
      appId: Settings.OneSignalAppId,
      allowLocalhostAsSecureOrigin: true,
    })
    OneSignal.Slidedown.promptPush()
  }
  useEffect(() => {
    runOneSignal()
  }, [])
  return (
    <Switch>
      {/* pages */}
      <RouteWithSidebar
        exact
        path={Routes.VehicleDetails.path}
        component={HomePage}
      />
      <RouteWithSidebar exact path={Routes.Search.path} component={HomePage} />
      <RouteWithSidebar
        exact
        path={Routes.VehicleVisits.path}
        component={HomePage}
      />
      <RouteWithSidebar exact path={Routes.Home.path} component={HomePage} />
      <RouteWithSidebar
        exact
        path={Routes.CustomerDetails.path}
        component={CustomerDetailPage}
      />
      <RouteWithSidebar
        exact
        path={Routes.Dashboard.path}
        component={DashboardPage}
      />
      <RouteWithSidebar exact path={Routes.chat.path} component={HomePage} />

      <RouteWithSidebar
        exact
        path={Routes.visitReport.path}
        component={VisitReportPage}
      />
      <RouteWithSidebar
        exact
        path={Routes.PlaceDetails.path}
        component={HomePage}
      />
      <RouteWithSidebar
        exact
        path={Routes.Customers.path}
        component={CustomerPage}
      />

      <RouteWithSidebar
        exact
        path={Routes.Agents.path}
        component={AgentsPage}
      />
      <RouteWithSidebar
        exact
        path={Routes.AgentDetails.path}
        component={AgentDetailsPage}
      />
      <Route
        exact
        path={Routes.SelectOrganization.path}
        component={SelectOrganization}
      />

      <Route path={Routes.SignIn.path} component={Login} />

      <RouteWithSidebar
        exact
        path={Routes.Settings.path}
        component={SettingsPage}
      />
      <RouteWithSidebar
        exact
        path={Routes.agentVisitsReport.path}
        component={AgentVisitsPage}
      />
      <Redirect to={Routes.SignIn.path} />
    </Switch>
  )
}
